jQuery(function ($) {
  const $headerLinks = $('nav#site-navigation a[href*="#"]');
  let sections = [];

  function getHeaderOffset() {
    return $('.site-header').outerHeight() || 0;
  }

  // Sticky nav class toggle
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 0) {
      $('#site-navigation').addClass('scrolled');
    } else {
      $('#site-navigation').removeClass('scrolled');
    }
  });

  // Unified anchor click handler: handles both scroll and tab logic
  $('a[href*="#"]').on('click', function (e) {
    const isDropdown = $(this).parent().hasClass('menu-item-has-children');
    const isTabLink = $(this).hasClass('service-tab');

    const targetId = this.hash;
    const $target = $(targetId);

    if ($target.length) {
      e.preventDefault();

      // Activate tab if it's a tab link
      if (isTabLink) {
        $('.service-tab').removeClass('active');
        $('.service').addClass('hidden').removeClass('active');

        $(this).addClass('active');
        $target.removeClass('hidden').addClass('active');
      }

      // Scroll to anchor
      $('html, body').animate({ scrollTop: $target.offset().top + getHeaderOffset() + 200 }, 800);
    }
  });

  // On page load: show correct tab if hash matches
  function activateServiceFromHash() {
    const hash = window.location.hash;
    if (!hash) return;

    const $tab = $(`.service-tab[href="${hash}"]`);
    const $target = $(hash);

    if ($tab.length && $target.length) {
      // If it's a tab link
      $('.service-tab').removeClass('active');
      $('.service').addClass('hidden').removeClass('active');
      $tab.addClass('active');
      $target.removeClass('hidden').addClass('active');

      setTimeout(() => {
        $('html, body').animate({
          scrollTop: $target.offset().top - getHeaderOffset() - 283
        }, 800);
      }, 50);

    } else if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top - getHeaderOffset() - 125
      }, 800);
    }
  }

  activateServiceFromHash();

  // Section offset calculation (optional)
  function updateSectionOffsets() {
    sections = [];

    $headerLinks.each(function () {
      const hash = this.hash;
      const $section = $(hash);

      if ($section.length) {
        sections.push({
          id: hash,
          top: $section.offset().top - getHeaderOffset(),
          bottom: $section.offset().top + $section.outerHeight(),
        });
      }
    });
  }

  $(window).on('load resize', updateSectionOffsets);
  setTimeout(updateSectionOffsets, 100);
});
